module.exports = __webpack_public_path__ + "static/media/arcabuco-360-preview.75373927.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/360photos/arcabuco-360-preview.jpg
// module id = 1154
// module chunks = 0